import api from './axios';

export async function add_user(email, password) {
    try {
        let res = await api.post('/auth/add-user', { email, password });
        res = res.data;
        return res;
    }
    catch (err) {
        throw err;
    }
}

export async function login(email, password) {
    try {
        let res = await api.post('/auth/login', { email, password });
        // השרת מחזיר כעת אובייקט עם token בתוכו
        return res.data; 
    }
    catch (err) {
        throw err;
    }
}

export async function send_temp_password(email) {
    try {
        const res = await api.post('/auth/send_temp_password', { email });
        return res.data;
    } catch (err) {
        throw err;
    }
}

export async function verify_temp_password(email, tempPassword) {
    try {
        const res = await api.post('/auth/verify_temp_password', {
            email,
            tempPassword
        });
        return res.data;
    } catch (err) {
        throw err;
    }
}

export async function change_password(email, newPassword) {
    try {
        const res = await api.post('/auth/change_password', {
            email,
            newPassword
        });
        return res.data;
    } catch (err) {
        throw err;
    }
}

// פונקציה לבדיקת תקינות הטוקן מול השרת
export async function verify_token() {
    try {
        const res = await api.get('/auth/verify_token');
        return res.data; 
    } catch (err) {
        console.error("Token verification failed", err);
        throw err;
    }
}

export function logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('rememberMe');
    window.location.href = '/login'; 
}
